import React, { useState, useEffect } from "react";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { List } from "react-content-loader";
import { useSelector } from "react-redux";
import AddBankAccount from "../../Pages/bankAccount/AddBankAccount";

const Settings = () => {
  const isMenuOpen = useSelector((state) => state.sidebar.isMenuOpen);
  const [status, setStatus] = useState({
    emailVerified: null,
    documentsUploaded: null,
    verifiedByDonateGreat: null,
    bankAccountAdded: null,
  });
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL_DASHBOARD_URL}/progress`
        );
        const data = response.data;

        const newStatus = {
          emailVerified: data.is_email_verified === true,
          documentsUploaded: data.is_docs_provided === true,
          verifiedByDonateGreat: data.is_org_user_verified === true,
          bankAccountAdded: data.is_gateway_added === true,
        };

        setStatus(newStatus);
        setLoading(false);

        if (Object.values(newStatus).every((value) => value)) {
          navigate("/profile");
        }
      } catch (error) {
        console.error("Failed to fetch status:", error);
        setLoading(false);
      }
    };

    fetchStatus();
  }, [navigate]);

  const renderStatusIcon = (status) => {
    return status ? (
      <CheckCircleOutlined style={{ color: "green", marginLeft: "8px" }} />
    ) : (
      <CloseCircleOutlined style={{ color: "red", marginLeft: "8px" }} />
    );
  };

  const handleAddBankAccount = () => {
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  if (loading) {
    return (
      <div
        className={`flex items-center justify-center min-h-screen ${
          isMenuOpen ? "ml-64" : "ml-10 rounded-none"
        } transition-all duration-300`}
      >
        <List
          speed={2}
          width={400}
          height={160}
          viewBox="0 0 400 160"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
        >
          <rect x="0" y="0" rx="5" ry="5" width="400" height="20" />
          <rect x="0" y="40" rx="5" ry="5" width="400" height="20" />
          <rect x="0" y="80" rx="5" ry="5" width="400" height="20" />
          <rect x="0" y="120" rx="5" ry="5" width="400" height="20" />
        </List>
      </div>
    );
  }

  return (
    <div
      className={`bg-[#41c0e0] sm:p-4 flex flex-col items-center pt-10 min-h-screen justify-center ${
        isMenuOpen ? "ml-64 " : "ml-10 rounded-none"
      } transition-all duration-300`}
    >
      <div className="bg-white shadow-md rounded-lg p-10 min-h-[50vh] min-w-[60vw] ml-28">
        <div className="flex items-center mb-4 justify-between text-2xl">
          <div>Email Verified</div>
          <div>{renderStatusIcon(status.emailVerified)}</div>
        </div>
        <div className="flex items-center mb-4 justify-between text-2xl">
          <div>Documents Uploaded</div>
          <div>{renderStatusIcon(status.documentsUploaded)}</div>
        </div>
        <div className="flex items-center mb-4 justify-between text-2xl">
          <div>Verified By Donate Great</div>
          <div>{renderStatusIcon(status.verifiedByDonateGreat)}</div>
        </div>
        <div className="flex items-center justify-between text-2xl">
          <div>Bank Account Added</div>
          <div>
            {!status.bankAccountAdded && (
              <Button
                type="primary"
                onClick={handleAddBankAccount}
                style={{ marginLeft: "8px" }}
              >
                Add Bank Account
              </Button>
            )}
          </div>
        </div>
      </div>
      <Modal
        title="KYC Details"
        open={isModalVisible}
        footer={null}
        onCancel={handleModalClose}
      >
        <AddBankAccount onClose={handleModalClose} />
      </Modal>
    </div>
  );
};

export default Settings;
